import {
  FETCH_DRIVER_REMARKS,
  FETCH_DRIVER_REMARKS_SUCCESS,
  FETCH_DRIVER_REMARKS_FAILED,
  FETCH_ALL_DRIVER_REMARKS,
  FETCH_ALL_DRIVER_REMARKS_SUCCESS,
  FETCH_ALL_DRIVER_REMARKS_FAILED,
  ADD_DRIVER_REMARK,
  EDIT_DRIVER_REMARK,
  DELETE_DRIVER_REMARK,
  CLEAR_DRIVER_REMARKS_ERROR,
} from "../store/types";
import { firebase } from "../config/configureFirebase";
import { onValue, get, push, update, remove, off, serverTimestamp } from "firebase/database";
import store from "../store/store";

export const fetchDriverRemarks = (driverId) => (dispatch) => {
  const { auth } = store.getState();
  if (auth.profile && auth.profile.uid) {
    const { driverRemarksByDriverRef } = firebase;
    
    dispatch({
      type: FETCH_DRIVER_REMARKS,
      payload: null,
    });

    const remarksRef = driverRemarksByDriverRef(driverId);

    onValue(remarksRef, (snapshot) => {
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data)
          .filter((key) => data[key].driverId === driverId)
          .map((key) => ({ id: key, ...data[key] }))
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        
        dispatch({
          type: FETCH_DRIVER_REMARKS_SUCCESS,
          payload: arr,
        });
      } else {
        dispatch({
          type: FETCH_DRIVER_REMARKS_SUCCESS,
          payload: [],
        });
      }
    });
  }
};

export const addDriverRemark = (remarkData) => (dispatch) => {
  const { auth } = store.getState();
  const { driverRemarksRef, singleUserRef } = firebase;
  
  dispatch({
    type: ADD_DRIVER_REMARK,
    payload: { loading: true },
  });

  const newRemarkData = {
    ...remarkData,
    agentId: auth.profile.uid,
    agentEmail: auth.profile.email,
    agentName: auth.profile.firstName + " " + auth.profile.lastName,
    timestamp: new Date().toISOString(),
    createdAt: serverTimestamp(),
  };

  push(driverRemarksRef, newRemarkData)
    .then(() => {
      dispatch({
        type: ADD_DRIVER_REMARK,
        payload: { success: true },
      });
      
      // Update last contact in driver record
      if (remarkData.callType && remarkData.callType !== 'Other') {
        update(singleUserRef(remarkData.driverId), {
          lastContactDate: newRemarkData.timestamp,
          lastContactType: remarkData.callType,
          lastContactAgent: auth.profile.email,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: ADD_DRIVER_REMARK,
        payload: { error: error.message },
      });
    });
};

export const editDriverRemark = (remarkId, updateData) => (dispatch) => {
  const { editDriverRemarkRef } = firebase;
  
  dispatch({
    type: EDIT_DRIVER_REMARK,
    payload: { loading: true },
  });

  const updatedData = {
    ...updateData,
    updatedAt: serverTimestamp(),
    updatedTimestamp: new Date().toISOString(),
  };

  update(editDriverRemarkRef(remarkId), updatedData)
    .then(() => {
      dispatch({
        type: EDIT_DRIVER_REMARK,
        payload: { success: true },
      });
    })
    .catch((error) => {
      dispatch({
        type: EDIT_DRIVER_REMARK,
        payload: { error: error.message },
      });
    });
};

export const deleteDriverRemark = (remarkId) => (dispatch) => {
  const { editDriverRemarkRef } = firebase;
  
  dispatch({
    type: DELETE_DRIVER_REMARK,
    payload: { loading: true },
  });

  remove(editDriverRemarkRef(remarkId))
    .then(() => {
      dispatch({
        type: DELETE_DRIVER_REMARK,
        payload: { success: true },
      });
    })
    .catch((error) => {
      dispatch({
        type: DELETE_DRIVER_REMARK,
        payload: { error: error.message },
      });
    });
};

export const clearDriverRemarksError = () => (dispatch) => {
  dispatch({
    type: CLEAR_DRIVER_REMARKS_ERROR,
    payload: null,
  });
};

// Stop listening to remarks updates
export const stopFetchingDriverRemarks = (driverId) => (dispatch) => {
  const { driverRemarksByDriverRef } = firebase;
  const remarksRef = driverRemarksByDriverRef(driverId);
  off(remarksRef);
};

// Fetch ALL driver remarks for agent performance dashboard.
// fromIso (optional ISO-8601 string): non-empty → indexed range read of remarks
// stamped on/after it (driverRemarksSinceRef) so the portal never pulls the
// whole /driver_remarks tree; null/undefined → the original full read.
export const fetchAllDriverRemarks = (fromIso = null) => async (dispatch) => {
  const { auth } = store.getState();
  if (auth.profile && auth.profile.uid) {
    const { driverRemarksRef, driverRemarksSinceRef } = firebase;

    dispatch({
      type: FETCH_ALL_DRIVER_REMARKS,
      payload: null,
    });

    try {
      const snapshot = await get(
        typeof fromIso === 'string' && fromIso ? driverRemarksSinceRef(fromIso) : driverRemarksRef
      );
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data)
          .map((key) => ({ id: key, ...data[key] }))
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

        dispatch({
          type: FETCH_ALL_DRIVER_REMARKS_SUCCESS,
          payload: arr,
        });
      } else {
        dispatch({
          type: FETCH_ALL_DRIVER_REMARKS_SUCCESS,
          payload: [],
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_ALL_DRIVER_REMARKS_FAILED,
        payload: error.message,
      });
    }
  }
};

// Stop listening to all remarks updates
export const stopFetchingAllDriverRemarks = () => (dispatch) => {
  const { driverRemarksRef } = firebase;
  off(driverRemarksRef);
};
